export const getSubAgentDisplayInput = (input: unknown): string | undefined => {
  if (typeof input === 'object' && input !== null) {
    const inputObj = input as Record<string, unknown>;
    if (typeof inputObj.query === 'string') {
      return inputObj.query;
    }
  }
  return undefined;
};
